

import { Component, Prop, Vue } from "vue-property-decorator"
import { CaseDetails } from "@/types"

import { State } from "vuex-class"
import { TenantFeatures } from "@/types/tenantFeatures"

@Component({})
export default class CaseSubheader extends Vue {
	@State tenantEnabledFeatures!: { [key: string]: boolean }

	@Prop()
	public currentCase!: CaseDetails | null

	public get sourceTypeEnabled (): boolean {
		return this.tenantEnabledFeatures[TenantFeatures.SourceType] && !!this.currentCase?.sourceType
	}
}
